"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeSelectStyles = function makeSelectStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiSelect: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          color: tokens.colors["ink-on-background"].rgb
        }, tokens.typography["body-copy-medium-compact"]), {}, {
          backgroundColor: tokens.colors["field-fill"].rgb,
          "& em": {
            color: tokens.colors["ink-on-background-60"].rgb,
            fontStyle: "normal"
          },
          "&[aria-expanded='true'] + input + .DhigSvgIcon--type--ui-control-icon": {
            transform: "rotate(180deg)"
          },
          "& .DhigSelect--option": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            "& + .DhigSelect--checkedIcon": {
              display: "none"
            }
          }
        }),
        outlined: {
          "&&": {
            paddingRight: primitives.spacings["3"]
          }
        },
        select: {
          minHeight: "inherit"
        }
      }
    }
  };
};

exports.makeSelectStyles = makeSelectStyles;